import React from 'react';

export function isForwardRefComponent(element: React.ReactNode): boolean {
    if (!React.isValidElement(element)) return false;

    if (typeof element.type === 'string') return true;

    return !!(
        typeof element === 'object' &&
        // @ts-expect-error TS doesn't like reaching into $$typeof
        element?.type?.$$typeof?.toString() === 'Symbol(react.forward_ref)'
    );
}
